module.exports = __webpack_public_path__ + "static/img/game9.2dc68a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/game9.jpg
// module id = dBuW
// module chunks = 1